
import Button from '../../../components/base/Button';

export default function RegistrationSection() {
  const steps = [
    {
      title: 'Instala la APP',
      description: 'La descarga de la APP podrás hacerla desde cualquiera de las dos plataformas de dispositivos populares: Android y Apple. Utiliza el término \'Campamento Real\' para localizarla o ve directamente pulsando en los enlaces del pie de página.',
      icon: 'ri-smartphone-line'
    },
    {
      title: 'Completa el registro',
      description: 'Rellena los campos del formulario de registro para poder participar en el sorteo. El período estará abierto desde las 12:00h del 18-11-2025 hasta las 23:59h del 30-11-2025',
      icon: 'ri-edit-line'
    },
    {
      title: 'Comprueba tu suerte',
      description: 'Utiliza tus datos para comprobar si has tenido suerte en el sorteo que se celebrará el 2-12-2025. Podrás completar el donativo hasta el 15-12-2025, visualizar y compartir tus accesos en PDF desde la propia APP.',
      icon: 'ri-gift-2-line'
    }
  ];

  return (
    <section id="registro" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/dafbd4640be181f0f420167676017526.png" 
              alt="Pasos para el registro" 
              className="w-80 h-auto rounded-lg shadow-lg mx-auto"
            />
          </div>

          <div>
            <div className="mb-12">
              <h1 className="text-4xl font-bold text-gray-900 mb-6">Registro y sorteo</h1>
              <p className="text-lg text-gray-600 leading-relaxed">
                Si has llegado aquí es porque tu objetivo es completar el registro y participar en el sorteo 
                de los accesos al Campamento Real.
              </p>
            </div>

            <div className="space-y-8">
              {steps.map((step, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                      <i className={`${step.icon} text-xl text-red-600`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                href="https://apps.apple.com/app/campamento-real/id6467151946"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-apple-line"></i>
                </div>
                Descargar iOS
              </Button>
              <Button 
                variant="secondary" 
                href="https://play.google.com/store/apps/details?id=es.campamentoreal.clientapp"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-google-play-line"></i>
                </div>
                Descargar Android
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
